import type { Either, ApiFailure, ApiSuccess } from '@/core/either/either.type';
import { left } from '@/core/either';

/**
 * Limita la frecuencia de ejecución de una función asíncrona que retorna Either
 * @param func - Función asíncrona que retorna ApiResult<T>
 * @param delay - Tiempo de espera en milisegundos entre llamadas
 * @returns Función throttled que retorna ApiResult<T>
 */
export function throttleEither<T, Args extends any[]>(
  func: (...args: Args) => Promise<Either<ApiFailure, ApiSuccess<T>>>,
  delay: number
): (...args: Args) => Promise<Either<ApiFailure, ApiSuccess<T>>> {
  let lastCall = 0;

  return async function (...args: Args): Promise<Either<ApiFailure, ApiSuccess<T>>> {
    const now = Date.now();

    if (now - lastCall >= delay) {
      lastCall = now;
      return await func(...args);
    }

    const throttleError: ApiFailure = {
      code: 'THROTTLED',
      reason: 'THROTTLED',
      status: 429,
      message: 'Por favor, espere unos segundos e intente nuevamente.',
    };

    return left(throttleError);
  };
}
